<template>
    <div class="full-screen">
      <index-pc v-if="w >= 800"></index-pc>
      <index-mp v-else></index-mp>
    </div>
</template>

<style scoped>
    .full-screen {
        width: 100%;
        height: 100%;
    }
</style>

<script>
import indexPc from "../../../src/components/page/index_pc.vue";
import indexMp from "../../../src/components/page/index_mp.vue";

export default {
  data() {
    return {
      w: window.innerWidth
    };
  },
  components: {
    indexPc,
    indexMp
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.w = window.innerWidth;
    });
  }
};
</script>